export const locale = {
    lang: 'fr',
    data: {
        HEADER: {
            'MEGA_MENU': 'Année scolaire',
        },
        SIDENAV: {
            DASHBOARDS: 'Tableaux de bord',
            MAILBOX: 'boîte de réception',
            CHAT: 'Bavarder',
            KNOWLADGE_BASE: 'Base de connaissances',
            CALENDAR: 'Calendrier',
            CONTACTS: 'Contacts',
        },
    }
};
